import React, { useRef, useState, FC } from 'react';
import { ISuperAdminListActionColProps, SuperAdminOptionText, ISuperAdminOption } from '../../../../../../lib/types';
import { Button, Select } from '../../../../../../ps-aspect-design';
import { useToast, ToastProps } from 'ps-shared-ui/v4/Toast';
import axios from 'ps-components/lib/apiClient';

const SuperAdminListActionCol: FC<ISuperAdminListActionColProps> = ({ row, getSuperAdmins, setState }) => {
  const options: ISuperAdminOption[] = [
    { key: 'default', text: 'Select', endpoint: '', description: '' },
    { key: 'superAdminStatus', text: 'Revoke Super Admin Status', endpoint: 'revokeSuperAdmin', description: 'revoke super admin' },
    { key: 'superAdminWhiteList', text: (`${row.superAdminWhiteList ? 'Revoke' : 'Grant'} Super Admin Whitelist`) as SuperAdminOptionText, endpoint: 'updateWhiteList', description: 'update super admin white list' },
    { key: 'siteCreationWhiteList', text: (`${row.siteCreationWhiteList ? 'Revoke' : 'Grant'} Site Creation Whitelist`) as SuperAdminOptionText, endpoint: 'updateWhiteList', description: 'update site creation white list' },
    { key: 'uniqueRangesWhiteList', text: (`${row.uniqueRangesWhiteList ? 'Revoke' : 'Grant'} Unique Ranges Whitelist`) as SuperAdminOptionText, endpoint: 'updateWhiteList', description: 'update unique ranges white list' }
  ];

  const ref = useRef()
  const toast = useToast()
  const [selectedOptionText, setSelectedOptionText] = useState<SuperAdminOptionText>('Select')
  const [selectedOption, setSelectedOption] = useState<ISuperAdminOption>(options[0])

  const toastConfig: ToastProps = {
    duration: 10000,
    isCloseable: true,
    type: 'error'
  };


  const handleChange = (actionText: SuperAdminOptionText) => {
    setSelectedOptionText(actionText)
    const matchedOption = (options.find(o => o.text === actionText)) as ISuperAdminOption
    setSelectedOption(matchedOption)
  }

  const handleSubmit = async () => {
    setState({ loading: true });
    try {
      const userId = row.user_id
      const { endpoint, key: whitelist } = selectedOption
      const operation = selectedOption.text.split(' ')[0].toLowerCase()
      const res = await axios.apiPost(`/api/generic-user/superadmin/${endpoint}`, { userId, operation, whitelist });
      if (res.data.success) getSuperAdmins();
      else toast(`failed to ${selectedOption.description}  ${res.data.message}`, toastConfig);
    } catch (err) {
      toast(`Failed to  ${selectedOption.description}`, toastConfig);
    } finally {
      setState({ loading: false });
      setSelectedOptionText('Select')
      setSelectedOption(options[0])
    }
  }

  return (
    <div style={{ display: 'flex', gap: 10 }}>
      <Select
        componentRef={ref as any}
        options={options}
        handleChange={handleChange}
        value={selectedOptionText}
      />
      <Button disabled={selectedOption.key === 'default'} onClick={() => handleSubmit()}>go</Button>
    </div>
  );
}

export default SuperAdminListActionCol;
